{
  "name": "arc-sdk-test",
  "version": "0.0.56",
  "description": "Arcane Privacy SDK",
  "type": "module",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "sideEffects": false,
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.js"
      },
      "require": {
        "types": "./dist/index.d.cts",
        "default": "./dist/index.cjs"
      }
    },
    "./circuits/paths": {
      "import": "./dist/circuits/paths.js",
      "require": "./dist/circuits/paths.cjs",
      "default": "./dist/circuits/paths.js"
    },
    "./circuits/*": "./dist/circuits/*",
    "./vite": {
      "import": {
        "types": "./dist/vite/index.d.ts",
        "default": "./dist/vite/index.js"
      },
      "require": {
        "types": "./dist/vite/index.d.cts",
        "default": "./dist/vite/index.cjs"
      }
    },
    "./react": {
      "import": {
        "types": "./dist/react/index.d.ts",
        "default": "./dist/react/index.js"
      },
      "require": {
        "types": "./dist/react/index.d.cts",
        "default": "./dist/react/index.cjs"
      }
    },
    "./package.json": "./package.json"
  },
  "peerDependencies": {
    "@solana/wallet-adapter-react": ">=0.15.0",
    "react": ">=18"
  },
  "peerDependenciesMeta": {
    "@solana/wallet-adapter-react": {
      "optional": true
    },
    "react": {
      "optional": true
    }
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "prepare:snarkjs": "node scripts/prepare-snarkjs.mjs",
    "build": "npm run prepare:snarkjs && tsup",
    "dev": "npm run prepare:snarkjs && tsup --watch",
    "typecheck": "npm run prepare:snarkjs && tsc --noEmit",
    "prepublishOnly": "npm run build"
  },
  "keywords": [
    "arc-sdk-test",
    "sdk"
  ],
  "license": "MIT",
  "devDependencies": {
    "@solana/wallet-adapter-react": "^0.15.39",
    "@types/node": "^26.0.0",
    "@types/react": "^19.1.8",
    "react": "^19.1.0",
    "tsup": "^8.5.0",
    "typescript": "^5.8.3"
  },
  "engines": {
    "node": ">=18"
  },
  "dependencies": {
    "@coral-xyz/anchor": "^0.31.1",
    "@solana/spl-token": "^0.4.14",
    "@solana/web3.js": "^1.98.4",
    "@switchboard-xyz/common": "^5.8.1",
    "@switchboard-xyz/on-demand": "^3.10.1",
    "buffer": "^6.0.3",
    "ffjavascript": "^0.3.1",
    "fixed-merkle-tree": "^0.7.3",
    "poseidon-hash": "^1.0.1",
    "tweetnacl": "^1.0.3"
  }
}
